import React from 'react'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import { Link } from 'react-router-dom'

const ScholarshipCard = ({scholarship}) => {
  return (
    <div className='w-full p-[20px] bg-gray-50'>
        <h3 className='font-medium text-gray-800 text-lg mb-2'>{scholarship.name}</h3>
        <p className='text-sm text-gray-600'>{scholarship.description.slice(0,120)}{scholarship.description.length > 120 ? '...' : ''}</p>
        
        {scholarship.limits.limited && <span className='inline-block mt-[7px] px-[10px] py-[5px] bg-orange-300 font-space-grotesk bg-opacity-20 rounded text-xs'>Limited to {scholarship.limits.quantity.toLocaleString()} students</span>}
        {!scholarship.limits.limited && <span className='inline-block px-[10px] py-[5px] mt-[10px] bg-green-500 font-medium font-space-grotesk bg-opacity-10 text-xs rounded '>Unlimited</span>}

        <div className='mt-[10px]'>
            {scholarship.discount.type === 'PERCENTAGE' ?
                <p className='text-sm text-gray-600'><span className='text-black font-space-grotesk font-medium'>{scholarship.discount.amount}%</span> off all eligible invoices</p>
            :
                <p className='text-sm text-gray-600'><span className='text-black font-space-grotesk font-medium'>N{scholarship.discount.amount.toLocaleString()}</span> off all eligible invoices</p>
            }
        </div>

        <div className='mt-[20px] pt-[10px] border-t border-gray-300'>
            <Link to={`/admin/administration/scholarships/${scholarship._id}`} className='flex font-medium text-gray-600 items-center gap-x-[5px] font-space-grotesk text-sm transition duration-200 hover:text-black'>
                See Scholarship Details
                <ArrowIcon className={`w-4 h-4`} />
            </Link>
        </div>
    </div>
  )
}

export default ScholarshipCard